const weeeAdapter = data => {
  const { img, name, ...rest } = data;
  return { ...rest, image: img, title: name };
};

const defaultAdapter = data => {
  return data;
};

export { defaultAdapter, weeeAdapter };
